// src/views/purchase/approval/LookPictureModal.tsx
import React, { useEffect, useState } from "react";
import { Modal, Image, Spin, Empty } from "antd";
import { materialService } from "@/views/base/material/materialService";
import { getBaseImgLookUrl } from "@/utils/constants";
import useGlobalModel from "@/model/globalModel";

interface LookPictureModalProps {
    visible: boolean;
    materialCode: string; // 配件编码
    onClose: () => void;
}

export const LookPictureModal: React.FC<LookPictureModalProps> = ({
    visible,
    materialCode,
    onClose,
}) => {
    const [loading, setLoading] = useState(false);
    const [images, setImages] = useState<{ uid: string; url: string; name: string }[]>([]);
    const { CustomerData, shopAndOrg: { shopName, shopId } } = useGlobalModel()

    const parseFileList = (str: any) => {
        if (!str || typeof str !== 'string') {
            return [];
        }
        try {
            const arr = JSON.parse(str);
            return Array.isArray(arr) ? arr : [];
        } catch (err) {
            console.error('文件列表解析失败：', err);
            return [];
        }
    }
    // 单条查询配件图片
    const fetchLookPictures = async () => {
        if (!materialCode) return;
        setLoading(true);
        try {
            const { retData } = await materialService.onePicture(materialCode, shopId);
            if (retData.fileMsg) {
                setImages(parseFileList(retData.fileMsg));
            } else {
                setImages([]);
            }
        } catch (error) {
            console.error("获取配件图片失败：", error);
            setImages([]);
        } finally {
            setLoading(false);
        }
    };

    // 当模态框显示或配件编码变化时重新查询
    useEffect(() => {
        if (visible && materialCode) {
            fetchLookPictures();
        }
    }, [visible, materialCode]);

    return (
        <Modal
            title={`配件 (${materialCode})图片`}
            open={visible}
            onCancel={onClose}
            footer={null}
            centered
            width={800}
        // maskClosable={false}
        >
            {loading ? (
                // 加载状态
                <div style={{ textAlign: "center", padding: "50px 0" }}>
                    <Spin size="large" tip="加载图片中..." />
                </div>
            ) : images.length > 0 ? (
                <Image.PreviewGroup
                >
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: 16, padding: 16 }}>
                        {images.map((img) => (
                            <div key={img.uid} style={{ border: "1px solid #eee", borderRadius: 4, overflow: "hidden" }}>
                                <Image
                                    src={getBaseImgLookUrl(img.uid)}
                                    alt={img.name}
                                    style={{ width: "100%", height: 180, objectFit: "contain", cursor: "pointer" }}
                                />
                                <p style={{ padding: 8, textAlign: "center", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                    {img.name}
                                </p>
                            </div>
                        ))}
                    </div>
                </Image.PreviewGroup>
            ) : (
                // 无图片时显示空状态
                <Empty
                    description={
                        <span style={{ fontSize: 16 }}>没有找到该配件的图片</span>
                    }
                    style={{ padding: "50px 0" }}
                />
            )}
        </Modal>
    );
};